"use strict";

/**
 * Plugin for adding Document Center links.
 * User cpDocument to add to toolbar.
 * Plugin heavily modeled after link.js plugin.
 */
(function (global, factory) {
  factory(require("../froala_3.0.5/js/froala_editor"));
})(void 0, function (FE) {
  "use strict";

  FE = FE && FE.hasOwnProperty("default") ? FE["default"] : FE;
  Object.assign(FE.POPUP_TEMPLATES, {
    "cpDocument.insert": "[_BUTTONS_][_INPUT_LAYER_]"
  });

  FE.PLUGINS.cpDocument = function (editor) {
    var $ = window.$ || require("jquery");

    function get() {
      var $currentImage = editor.image ? editor.image.get() : null;

      if (!$currentImage && editor.$wp) {
        var s_el = editor.selection.element();
        var e_el = editor.selection.endElement();

        if (s_el.tagName != "A" && !editor.node.isElement(s_el)) {
          s_el = $(s_el).parentsUntil(editor.$el, "a:first").get(0);
        }

        if (e_el.tagName != "A" && !editor.node.isElement(e_el)) {
          e_el = $(e_el).parentsUntil(editor.$el, "a:first").get(0);
        }

        if (e_el && e_el == s_el && e_el.tagName == "A") {
          return s_el;
        }

        return null;
      } else if (editor.$el.get(0).tagName == "A" && editor.core.hasFocus()) {
        return editor.$el.get(0);
      } else {
        if ($currentImage && $currentImage.get(0).parentNode && $currentImage.get(0).parentNode.tagName == "A") {
          return $currentImage.get(0).parentNode;
        }

        return null;
      }
    }
    /**
     * Initialize the modal.  Returns the template that will be used.
     */


    function _initInsertPopup(delayed) {
      if (delayed) {
        editor.popups.onRefresh("cpDocument.insert", _refreshInsertPopup);
        return true;
      } // Image buttons.


      var link_buttons = "";

      if (editor.opts.linkInsertButtons.length >= 1) {
        link_buttons = '<div class="fr-buttons">' + editor.button.buildList(editor.opts.linkInsertButtons) + "</div>";
      }

      var checkmark = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg>'; // Image by url layer.

      var input_layer = "";
      var tab_idx = 0;
      input_layer = '<div class="fr-link-insert-layer fr-layer fr-active" id="fr-link-insert-layer-' + editor.id + '">';
      input_layer += '<div class="fr-input-line"><input name="href" type="text" class="fr-link-attr" placeholder="Link" tabIndex="' + ++tab_idx + '"></div>';

      if (editor.opts.linkText) {
        input_layer += '<div class="fr-input-line"><input name="text" type="text" class="fr-link-attr" placeholder="' + editor.language.translate("Text") + '" tabIndex="' + ++tab_idx + '"></div>';
      } // Add any additional fields.


      for (var attr in editor.opts.linkAttributes) {
        if (editor.opts.linkAttributes.hasOwnProperty(attr)) {
          var placeholder = editor.opts.linkAttributes[attr];
          input_layer += '<div class="fr-input-line"><input name="' + attr + '" type="text" class="fr-link-attr" placeholder="' + editor.language.translate(placeholder) + '" tabIndex="' + ++tab_idx + '"></div>';
        }
      }

      if (!editor.opts.linkAlwaysBlank) {
        input_layer += '<div class="fr-checkbox-line"><span class="fr-checkbox"><input name="target" class="fr-link-attr" data-checked="_blank" type="checkbox" id="fr-link-target-' + editor.id + '" tabIndex="' + ++tab_idx + '"><span>' + checkmark + '</span></span><label for="fr-link-target-' + editor.id + '">' + editor.language.translate("Open in new tab") + "</label></div>";
      }

      input_layer += '<div class="fr-action-buttons"><button class="fr-command fr-submit" data-cmd="cpDocumentInsert" href="#" tabIndex="' + ++tab_idx + '" type="button">' + editor.language.translate("Insert") + "</button></div></div>";
      var template = {
        buttons: link_buttons,
        input_layer: input_layer
      }; // Set the template in the popup.

      var $popup = editor.popups.create("cpDocument.insert", template);

      if (editor.$wp) {
        editor.events.$on(editor.$wp, "scroll.link-insert", function () {
          var $current_image = editor.image ? editor.image.get() : null;

          if ($current_image && editor.popups.isVisible("cpDocument.insert")) {
            imageLink();
          }

          if (get && editor.popups.isVisible("cpDocument.insert")) {
            update();
          }
        });
      }

      return $popup;
    }

    function allSelected() {
      var $current_image = editor.image ? editor.image.get() : null;
      var selectedLinks = [];

      if ($current_image) {
        if ($current_image.get(0).parentNode.tagName == "A") {
          selectedLinks.push($current_image.get(0).parentNode);
        }
      } else {
        var range;
        var containerEl;
        var links;
        var linkRange;

        if (editor.win.getSelection) {
          var sel = editor.win.getSelection();

          if (sel.getRangeAt && sel.rangeCount) {
            linkRange = editor.doc.createRange();

            for (var r = 0; r < sel.rangeCount; ++r) {
              range = sel.getRangeAt(r);
              containerEl = range.commonAncestorContainer;

              if (containerEl && containerEl.nodeType != 1) {
                containerEl = containerEl.parentNode;
              }

              if (containerEl && containerEl.nodeName.toLowerCase() == "a") {
                selectedLinks.push(containerEl);
              } else {
                links = containerEl.getElementsByTagName("a");

                for (var i = 0; i < links.length; ++i) {
                  linkRange.selectNodeContents(links[i]);

                  if (linkRange.compareBoundaryPoints(range.END_TO_START, range) < 1 && linkRange.compareBoundaryPoints(range.START_TO_END, range) > -1) {
                    selectedLinks.push(links[i]);
                  }
                }
              }
            }
          }
        } else if (editor.doc.selection && editor.doc.selection.type != "Control") {
          range = editor.doc.selection.createRange();
          containerEl = range.parentElement();

          if (containerEl.nodeName.toLowerCase() == "a") {
            selectedLinks.push(containerEl);
          } else {
            links = containerEl.getElementsByTagName("a");
            linkRange = editor.doc.body.createTextRange();

            for (var j = 0; j < links.length; ++j) {
              linkRange.moveToElementText(links[j]);

              if (linkRange.compareEndPoints("StartToEnd", range) > -1 && linkRange.compareEndPoints("EndToStart", range) < 1) {
                selectedLinks.push(links[j]);
              }
            }
          }
        }
      }

      return selectedLinks;
    }
    /**
     * Display the Insert link modal
     */


    function _showInsertPopup(href, linkName) {
      var $btn = editor.$tb.find('.fr-command[data-cmd="cpDocument"]');
      var $popup = editor.popups.get("cpDocument.insert");
      if (!$popup) $popup = _initInsertPopup();

      if (!$popup.hasClass("fr-active")) {
        editor.popups.refresh("cpDocument.insert");
        editor.popups.setContainer("cpDocument.insert", editor.$tb || $(editor.opts.scrollableContainer));
        $popup.find('input.fr-link-attr[type="text"][name="href"]').val(href);
        editor.selection.restore();
        var selection = editor.selection.text();

        if (selection != null && selection !== "") {
          linkName = selection;
        }

        $popup.find('input.fr-link-attr[type="text"][name="text"]').val(linkName);
        $popup.find('input.fr-link-attr[type="checkbox"][name="target"]').val("checked", true);
        $popup.find('input.fr-link-attr[type="text"][name="text"]').trigger("change");
        $popup.find('input.fr-link-attr[type="text"][name="href"]').trigger("change");

        if (!$btn.is("hidden")) {
          var left = $btn.offset().left + $btn.outerWidth() / 2;
          var top = $btn.offset().top + (editor.opts.toolbarBottom ? 10 : $btn.outerHeight() - 10);
          editor.popups.show("cpDocument.insert", left, top, $btn.outerHeight());
        } else {
          editor.position.forSelection($popup);
          editor.popups.show("cpDocument.insert");
        }
      }
    }
    /**
     * Edit functions are directly from link.js plugin.
     * We want to just open that modal after inserting document link.
     */


    function _hideEditPopup() {
      editor.popups.hide("link.edit");
    }

    function _edit(e) {
      _hideEditPopup();

      setTimeout(function () {
        // No event passed.
        // Event passed and (left click or other event type).
        if (!e || e && (e.which == 1 || e.type != "mouseup")) {
          var link = get();
          var $current_image = editor.image ? editor.image.get() : null;

          if (link && !$current_image) {
            if (editor.image) {
              var contents = editor.node.contents(link); // https://github.com/froala/wysiwyg-editor/issues/1103

              if (contents.length == 1 && contents[0].tagName == "IMG") {
                var range = editor.selection.ranges(0);

                if (range.startOffset === 0 && range.endOffset === 0) {
                  $(link).before(FE.MARKERS);
                } else {
                  $(link).after(FE.MARKERS);
                }

                editor.selection.restore();
                return false;
              }
            }

            if (e) {
              e.stopPropagation();
            }

            _showEditPopup(link);
          }
        }
      }, editor.helpers.isIOS() ? 100 : 0);
    }

    function _showEditPopup(link) {
      var $popup = editor.popups.get("link.edit");
      if (!$popup) $popup = _initEditPopup();
      var $link = $(link);

      if (!editor.popups.isVisible("link.edit")) {
        editor.popups.refresh("link.edit");
      }

      editor.popups.setContainer("link.edit", $(editor.opts.scrollableContainer));
      var left = $link.offset().left + $(link).outerWidth() / 2;
      var top = $link.offset().top + $link.outerHeight();
      editor.popups.show("link.edit", left, top, $link.outerHeight());
    }

    function _initEditPopup() {
      // Link buttons.
      var link_buttons = "";

      if (editor.opts.linkEditButtons.length > 1) {
        if (editor.$el.get(0).tagName == "A" && editor.opts.linkEditButtons.indexOf("linkRemove") >= 0) {
          editor.opts.linkEditButtons.splice(editor.opts.linkEditButtons.indexOf("linkRemove"), 1);
        }

        link_buttons = '<div class="fr-buttons">' + editor.button.buildList(editor.opts.linkEditButtons) + "</div>";
      }

      var template = {
        buttons: link_buttons
      }; // Set the template in the popup.

      var $popup = editor.popups.create("link.edit", template);

      if (editor.$wp) {
        editor.events.$on(editor.$wp, "scroll.link-edit", function () {
          if (get() && editor.popups.isVisible("link.edit")) {
            _showEditPopup(get());
          }
        });
      }

      return $popup;
    }

    function _split() {
      if (!editor.selection.isCollapsed()) {
        editor.selection.save();
        var markers = editor.$el.find(".fr-marker").addClass("fr-unprocessed").toArray();

        while (markers.length) {
          var $marker = $(markers.pop());
          $marker.removeClass("fr-unprocessed");
          var deep_parent = editor.node.deepestParent($marker.get(0));

          if (deep_parent) {
            var node = $marker.get(0);
            var close_str = "";
            var open_str = "";

            do {
              node = node.parentNode;

              if (!editor.node.isBlock(node)) {
                close_str = close_str + editor.node.closeTagString(node);
                open_str = editor.node.openTagString(node) + open_str;
              }
            } while (node != deep_parent);

            var marker_str = editor.node.openTagString($marker.get(0)) + $marker.html() + editor.node.closeTagString($marker.get(0));
            $marker.replaceWith('<span id="fr-break"></span>');
            var h = $(deep_parent).html();
            h = h.replace(/<span id="fr-break"><\/span>/g, close_str + marker_str + open_str);
            $(deep_parent).html(h);
          }

          markers = editor.$el.find(".fr-marker.fr-unprocessed").toArray();
        }

        editor.selection.restore();
      }
    }
    /**
     * Called when Insert button is clicked on modal
     **/


    function insert(href, text, attrs) {
      if (typeof attrs == "undefined") attrs = {}; // Get image if we have one selected.

      var $current_image = editor.image ? editor.image.get() : null;

      if (!$current_image && editor.$el.get(0).tagName != "A") {
        editor.selection.restore();
        editor.popups.hide("cpDocument.insert");
      } else if (editor.$el.get(0).tagName == "A") {
        editor.$el.focus();
      }

      var original_href = href; // Convert email address.

      if (editor.opts.linkConvertEmailAddress) {
        var regex = /^[\w._]+@[a-z\u00a1-\uffff0-9_-]+?\.[a-z\u00a1-\uffff0-9]{2,}$/i;

        if (regex.test(href) && !/^mailto:.*/i.test(href)) {
          href = "mailto:" + href;
        }
      } // Add autoprefix.


      if (editor.opts.linkAutoPrefix !== "" && !/^(mailto|tel|sms|notes|data):.*/i.test(href) && !/^data:image.*/i.test(href) && !/^(https?:|ftps?:|file:|)\/\//i.test(href)) {
        // Do prefix only if starting character is not absolute.
        if (["/", "{", "[", "#", "("].indexOf((href || "")[0]) < 0) {
          href = editor.opts.linkAutoPrefix + href;
        }
      } // Sanitize the URL.


      href = editor.helpers.sanitizeURL(href); // Default attributs.

      if (editor.opts.linkAlwaysBlank) attrs.target = "_blank";
      if (editor.opts.linkAlwaysNoFollow) attrs.rel = "nofollow"; // Format text.

      text = text || ""; // Check if we have selection only in one link.

      var link = get();
      var $link;

      if (link) {
        $link = $(link); // Clear attributes.

        var a_list = editor.node.rawAttributes(link);

        for (var attr in a_list) {
          if (a_list.hasOwnProperty(attr)) {
            if (attr != "class" && attr != "style") {
              $link.removeAttr(attr);
            }
          }
        }

        $link.attr("href", href); // Change text if it is different.

        if (text.length > 0 && $link.text() != text && !$current_image) {
          $link.text(text);
        }

        if (!$current_image) {
          $link.prepend(FE.START_MARKER).append(FE.END_MARKER);
        } // Set attributes.


        $link.attr(attrs);

        if (!$current_image) {
          editor.selection.restore();
        }
      } else {
        // We don't have any image selected.
        if (!$current_image) {
          // Remove current links.
          editor.format.remove("a"); // Nothing is selected.

          if (editor.selection.isCollapsed()) {
            text = text.length === 0 ? original_href : text;
            editor.html.insert('<a href="' + href + '">' + FE.START_MARKER + text + FE.END_MARKER + "</a>");
            editor.selection.restore();
          } else {
            if (text.length > 0 && text != editor.selection.text().replace(/\n/g, "")) {
              editor.selection.remove();
              editor.html.insert('<a href="' + href + '">' + FE.START_MARKER + text + FE.END_MARKER + "</a>");
              editor.selection.restore();
            } else {
              _split(); // Add link.


              editor.format.apply("a", {
                href: href
              });
            }
          }
        } else {
          // Just wrap current image with a link.
          $current_image.wrap('<a href="' + href + '"></a>');
        } // Set attributes.


        var links = allSelected();

        for (var i = 0; i < links.length; i++) {
          $link = $(links[i]);
          $link.attr(attrs);
          $link.removeAttr("_moz_dirty");
        } // Show link edit if only one link.


        if (links.length === 1 && editor.$wp && !$current_image) {
          $(links[0]).prepend(FE.START_MARKER).append(FE.END_MARKER);
          editor.selection.restore();
        }
      } // Hide popup and try to edit.


      if (!$current_image) {
        _edit();
      } else {
        var $pop = editor.popups.get("cpDocument.insert");
        $pop.find("input:focus").blur();
        editor.image.edit($current_image);
      }
    }
    /**
     * Insert link into the editor.  Called Insert/Update is clicked in Modal.
     */


    function insertCallback() {
      var $popup = editor.popups.get("cpDocument.insert");
      var text_inputs = $popup.find('input.fr-link-attr[type="text"]');
      var check_inputs = $popup.find('input.fr-link-attr[type="checkbox"]');
      var href = text_inputs.filter('[name="href"]').val();
      var text = text_inputs.filter('[name="text"]').val();
      var attrs = {};
      var $input;
      var i;

      for (i = 0; i < text_inputs.length; i++) {
        $input = $(text_inputs[i]);

        if (["href", "text"].indexOf($input.attr("name")) < 0) {
          attrs[$input.attr("name")] = $input.val();
        }
      }

      for (i = 0; i < check_inputs.length; i++) {
        $input = $(check_inputs[i]);

        if ($input.is(":checked")) {
          attrs[$input.attr("name")] = $input.data("checked");
        } else {
          attrs[$input.attr("name")] = $input.data("unchecked");
        }
      }

      var t = $(editor.o_win).scrollTop();
      insert(href, text, attrs);
      $(editor.o_win).scrollTop(t);
    }
    /**
     *  Called when clicking insert document link.
     */


    function insertDocument() {
      editor.selection.save();
      var promptUserForAssetsAsync = editor.opts.promptUserForAssetsAsync;
      var localShowInsertPopup = this.showInsertPopup;

      if (promptUserForAssetsAsync) {
        promptUserForAssetsAsync({
          allowMultipleChoices: false,
          imagesOnly: false
        }).then(function (selectedImages) {
          localShowInsertPopup(selectedImages[0].url, selectedImages[0].fileName);
        });
      }
    }
    /**
     * Refreshes the modal.  Applies the selected text to Text field.
     */


    function _refreshInsertPopup() {
      var $popup = editor.popups.get("cpDocument.insert");
      var link = get();

      if (link) {
        var $link = $(link);
        var textInputs = $popup.find('input.fr-link-attr[type="text"]');
        var checkInputs = $popup.find('input.fr-link-attr[type="checkbox"]');
        var i;
        var $input;

        for (i = 0; i < textInputs.length; i++) {
          $input = $(textInputs[i]);
          $input.val($link.attr($input.attr("name") || ""));
        }

        checkInputs.val("checked", false);

        for (i = 0; i < checkInputs.length; i++) {
          $input = $(checkInputs[i]);

          if ($link.attr($input.attr("name")) == $input.data("checked")) {
            $input.val("checked", true);
          }
        }

        $popup.find('input.fr-link-attr[type="text"][name="text"]').val($link.text());
      } else {
        $popup.find('input.fr-link-attr[type="text"]').val("");
        $popup.find('input.fr-link-attr[type="checkbox"]').val("checked", false);
        $popup.find('input.fr-link-attr[type="text"][name="text"]').val(editor.selection.text());
      }

      $popup.find("input.fr-link-attr").trigger("change");
      var $currentImage = editor.image ? editor.image.get() : null;

      if ($currentImage) {
        $popup.find('.fr-link-attr[name="text"]').parent().hide();
      } else {
        $popup.find('.fr-link-attr[name="text"]').parent().show();
      }
    }

    function _init() {
      _initInsertPopup(true);
    } //Return public methods.


    return {
      _init: _init,
      showInsertPopup: _showInsertPopup,
      insertCallback: insertCallback,
      insertDocument: insertDocument,
      allSelected: allSelected,
      get: get
    };
  }; //Register the Plugin.


  FE.DefineIcon("cpDocument", {
    NAME: "file",
    template: "font_awesome"
  });
  FE.RegisterCommand("cpDocument", {
    title: "Insert File Link",
    focus: true,
    undo: true,
    refreshAfterCallBack: false,
    callback: function callback() {
      this.cpDocument.insertDocument();
    }
  });
  FE.RegisterCommand("cpDocumentInsert", {
    focus: false,
    refreshAfterCallback: false,
    callback: function callback() {
      this.cpDocument.insertCallback();
    },
    refresh: function refresh($btn) {
      var link = this.cpDocument.get();

      if (link) {
        $btn.text(this.language.translate("Update"));
      } else {
        $btn.text(this.language.translate("Insert"));
      }
    }
  });
});